import React, { useEffect, useState } from 'react';
import Header from '../../shared/components/Header';
import { useGetDestinationByNameQuery } from '../../features/destination/destinationFetch';
import FullPageLoader from '../../shared/components/Loader';
import { Title, Body } from '@vds/typography';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { Icon } from '@vds/icons';
import { TextLink } from '@vds/buttons';
import Footer from '../../shared/components/Footer';
import { Modal, ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import { Button } from '@vds/buttons';
import { Line } from '@vds/lines';
import { useNavigate } from 'react-router-dom';
import { isDesktop, isInIframe, isMdot, isNative, SessionIdGlobal, unauth } from '../../shared/utils/globalConfig';
import { useDispatch,useSelector } from 'react-redux';
import { saveSelectedDestinations} from '../../features/selectedData/selectedDataReducer';
import { savePersistantDestinations, setSessionIdVar, setSessionIdVarUnauth, setVarConfirmToDevice  } from '../../features/selectedData/persistantDataReducer';
import { convertStringToElements } from '@vds/html-parsers';
import { nativeOpenInWebview, nativeSetTitleOnly } from '../../shared/utils/native';
import ErrorPage from '../../shared/components/ErrorPage';
import {dispatchPageView, setModelTagging} from '../../shared/utils/tagging'
import { useGetLandingByNameQuery } from '../../features/destination/landingPageFetch';
import xss from 'xss';
import { useItpPageTools } from '../../shared/hooks/useItpPageTools';
import { buildDestinationTools, emitItpStateChanged } from '../../shared/pageTools/itpPageTools';

const DestinationPageMain = styled.div`
`
const DestinationPage = styled.div`
height: ${isDesktop ? '65vh' : isNative ? '78vh' : isMdot ? '69vh' : ''};
overflow-y: auto;
scrollbar-width: thin;
#errorIcon {
    padding: 0px 4px;
}
.MuiAutocomplete-root {
    width: 328px;
}
.MuiAutocomplete-root input::placeholder {
    color: #6F7171;
    opacity: 1;
}
`
const Space = styled.div`
padding-top: ${props => props.pt || 8}px;
`
const CountryListWrapper = styled.div`
margin-top: 6px;
margin-bottom: 32px;
`

const CountryBtn = styled.div`
height: 32px;
display: inline-flex;
border-radius: 24px;
border: ${props => props.border === 'advisory' ? '1px solid #CC4D0F' : '1px solid'};
border-bottom: ${props => props.border === 'advisory' ? '4px solid #CC4D0F' : ''};
align-items: center;
margin-right: 10px;
margin-top: 10px;
cursor: pointer;
p {
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left:  ${props => props.border === 'advisory' ? '' : '12px'}; 
    padding-right: 12px;
    white-space: nowrap;
}
span {
    margin: 3px 5px 0 -6px;

}
&:focus {
    outline: dashed 1px;
    outline-offset: 2px;
}
`
const ErrorRestriction = styled.div`
display: flex;
margin-top:10px;
p {
    margin-top:3px;
    padding-left: 2px;
}
`
const StyledAdvisory = styled.div`
display: flex;
padding-bottom: 32px;
p {
    margin-top: 4px;
    margin-left: 2px;
}`

const StyledModalFooter = styled.div`
button{
    margin: auto;
}
`

export default function Destination() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { data, error, isLoading, isSuccess } = useGetDestinationByNameQuery();
    const { data: landingData, error:landingError } = useGetLandingByNameQuery();
    const { selectedDestinations } = useSelector(state => state?.persistantReducer);
    const { retainDatesAndDestinations } = useSelector(state => state?.selectedReducer);
    const [destinationaData, setDestinationData] = useState();
    const [selectedDestination, setSelectedDestination] = useState([]);
    const [showMaxLimitErrMsg, setShowMaxLimitErrMsg] = useState(false);
    const [showDestRestMsg, setShowDestRestMsg] = useState(false);
    const [destRestMsg, setDestRestMsg] = useState();
    const [dataSlowList, setDataSlowList] = useState([]);
    const [dataUnavailableList, setDataUnavailableList] = useState([]);
    const [showAdvisoryModal, setShowAdvisoryModal] = useState(false);
    const [advisoryModalDetails, setAdvisoryModalDetails] = useState();
    const [inputValue, setInputValue] = useState("");

    const filterOptions = (options, { inputValue }) => {
        let filteredDestinations = options.filter((item) => {
            const text = inputValue.toLowerCase();
            if (!!item.alias)
              if (item.alias && item.alias.toLowerCase().indexOf(text) > -1)
                return item.alias && item.alias.toLowerCase().indexOf(text) > -1;
              else return item.name && item.name.toLowerCase().indexOf(text) === 0;
            else
              return item.name && item.name.toLowerCase().indexOf(text) === 0;
          });
          return filteredDestinations;
    }

    const getErrorMessageVal = (key) => {
        const errorListMap = destinationaData && destinationaData.errorList.find((errorObj) => errorObj.errorCode === key)
        return errorListMap.errorMessage;
    }
    //Tagging
    useEffect(() => {
        if(isNative){
            nativeSetTitleOnly("International Plans");
        }
        if(!unauth){ 
            dispatch(setSessionIdVar(SessionIdGlobal));}
        if(unauth){ 
                dispatch(setSessionIdVarUnauth(SessionIdGlobal));}
    },[])

    useEffect(() => {
        setDestinationData(data?.body?.data?.destination);
        dispatch(setVarConfirmToDevice(false));
    }, [data])

    useEffect(() => {
        if(retainDatesAndDestinations)

        setSelectedDestination(selectedDestinations);
    }, [selectedDestinations, data])

     useEffect(() => {
        dispatchPageView('ITP_DestinationSelection', '','#destination_page', landingData?.body?.data?.landingPage?.mtnDetailList);
    }, [landingData?.body?.data?.landingPage?.mtnDetailList])

    useEffect(() => {
        if (landingError?.data?.responseInfo?.isRestrictedAccount)  {
            const restrictedUrl = landingError?.data?.responseInfo?.restrictedUrl;
            if (restrictedUrl) {
                window.location.href = xss(restrictedUrl);
            } else {
                console.error('Restricted account detected but no valid restrictedUrl provided');
            }
        }
    }, [landingError])

    const onRemove = (countryObj) => {
        setShowMaxLimitErrMsg(false);
        setSelectedDestination((selectedDestination) => selectedDestination.filter((v) => v.name !== countryObj.name));
        if (countryObj?.advisory) {
            if (countryObj?.advisory === 'DATA_SLOW') {
                setDataSlowList((dataSlowList) => dataSlowList.filter((countryname) => countryname !== countryObj.name))
            } else {
                setDataUnavailableList((dataUnavailableList) => dataUnavailableList.filter((countryname) => countryname !== countryObj.name))
            }
        }
        emitItpStateChanged();
    };

    const destinationUpdate = (newDest) => {
        if ((selectedDestination.filter((d) => d.name === newDest[newDest.length - 1]?.name)).length > 0) {
            return;
        }
        setShowDestRestMsg(false);
        if(newDest.length>0){
        if (newDest[newDest.length - 1]?.restriction) {
            setShowDestRestMsg(true);
            if (newDest[newDest.length - 1].restriction === 'NO_SERVICE') {
                setDestRestMsg(getErrorMessageVal('NO_SERVICE'))
            } else if (newDest[newDest.length - 1].restriction === 'PLAN_INCLUDED_COUNTRY') {
                setDestRestMsg(getErrorMessageVal('PLAN_INCLUDED_COUNTRY'))
            }
        } else if (selectedDestination.length >= destinationaData?.maxSelectLimit) {
            setShowMaxLimitErrMsg(true)
        } else {
            if (newDest[newDest.length - 1]?.advisory) {
                setSelectedDestination([...selectedDestination, newDest[newDest.length - 1]])
                if (newDest[newDest.length - 1].advisory === 'DATA_SLOW') {
                    setDataSlowList([...dataSlowList, newDest[newDest.length - 1].name]);
                } else if (newDest[newDest.length - 1].advisory === 'DATA_UNAVAILABLE') {
                    setDataUnavailableList([...dataUnavailableList, newDest[newDest.length - 1].name]);
                }
            } else {
                setSelectedDestination([newDest[newDest.length - 1], ...selectedDestination])
            }
            emitItpStateChanged();
        }}
    }

    const openAdvisoryModal = (key) => {
        setShowAdvisoryModal(true);
        setAdvisoryModalDetails(data?.body?.data[key]);
    }

    const getMessageValue = (key) => {
        const advListMap = destinationaData?.advisoryList.find((advObj) => advObj.messageCode === key)
        return advListMap.statusMessage.replace('#cta_1#', `<a>` + advListMap.ctaList[0].ctaLabel + `</a>`);
    }

    const getAdvisoryMessage = () => {
        if (dataSlowList.length > 0 && dataUnavailableList.length > 0) {
            return <StyledAdvisory data-testid="advisoryLinkId" onClick={() => { openAdvisoryModal('data_unavailable_or_data_slow') }}><Icon ariaHidden={true} name="error" size="large" color="#ff8027"></Icon><Body>{convertStringToElements(getMessageValue("DATA_UNAVAILABLE|DATA_SLOW"))}</Body></StyledAdvisory>
        } else if (dataSlowList.length > 0) {
            return <StyledAdvisory data-testid="advisoryLinkId" onClick={() => { openAdvisoryModal('data_slow') }}><Icon ariaHidden={true} name="error" size="large" color="#ff8027"></Icon><Body>{convertStringToElements(getMessageValue("DATA_SLOW"))}</Body></StyledAdvisory>
        } else {
            return <StyledAdvisory data-testid="advisoryLinkId" onClick={() => { openAdvisoryModal('data_unavailable') }}><Icon ariaHidden={true} name="error" size="large" color="#ff8027"></Icon><Body>{convertStringToElements(getMessageValue("DATA_UNAVAILABLE"))}</Body></StyledAdvisory>
        }
    }

    const getAdvisoryCountryList = (advType) => {
        if (advType === 'DATA_SLOW') {
            return dataSlowList.join(', ');
        } else if (advType === 'DATA_UNAVAILABLE') {
            return dataUnavailableList.join(', ')
        }
    }

    const onOpenedChange = value => {
        setModelTagging("DestinationadvisoryModal", 'DestinationadvisoryModal', value);
        if (!value) {
            setShowAdvisoryModal(false)
        }
    };
	
    
    const nextButtonClick = () => {
        dispatch(saveSelectedDestinations(selectedDestination))
        dispatch(savePersistantDestinations(selectedDestination))
        navigate(destinationaData?.ctaList[0]?.ctaUrl)
    }

    const openCoverageLink = () => {
        if (isNative) {
            nativeOpenInWebview(destinationaData?.coverageMapTextLink)
        } else {
            window.open(destinationaData?.coverageMapTextLink)
        }
    }
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            const filteredOptions = filterOptions(destinationaData?.destinationList, { inputValue })
            if (filteredOptions.length === 1 && !selectedDestination.some(item => item.key === filteredOptions[0].key)) {
                setSelectedDestination((prevValue) => [...prevValue, filteredOptions[0]]);
            }
        }
    }

    const destinationTools = buildDestinationTools({
        destinations: destinationaData?.destinationList ?? [],
        selectedDestinations: selectedDestination,
        onAddDestinations: destinationUpdate,
        onRemoveDestination: onRemove,
        onContinue: nextButtonClick,
    });

    useItpPageTools('intl-nsa-destination', destinationTools, {
        destinations: selectedDestination,
    });

    return (
        <DestinationPageMain id="destination_page">
            {(isSuccess && destinationaData) ?
                (<React.Fragment>
                    <DestinationPage>
                        <Header pageTitle={destinationaData?.pageTitle} progressData={destinationaData?.progressBar} />

                        <Title data-testid="destinationHeading" size="large" primitive="h3">{destinationaData?.heading}</Title>
                        <Space />
                        <Body size="large" data-testid="destinationsubText">{destinationaData?.subHeadingText}</Body>
                        <Space pt={24} />
                        <label for="destinations">
                        <Body data-testid="fieldLabel" size="small">{destinationaData?.textFieldLabel}</Body>
                        </label>                        
                        <Autocomplete
                            data-testid="textField"
                            style={{ width: isInIframe ? 'auto' : undefined }}
                            filterOptions={filterOptions}
                            multiple
                            forcePopupIcon={false}
                            open={inputValue.length !== 0}
                            inputValue={inputValue}
                            onInputChange={(e, value) => setInputValue(value)}
                            id="destinations"
                            sx={{ width: 300 }}
                            filterSelectedOptions={true}
                            disableClearable={true}
                            value={selectedDestination}
                            options={destinationaData?.destinationList}
                            getOptionLabel={(option) => option.name}
                            renderTags={() => null}
                            onChange={(e, newValue) => destinationUpdate(newValue)}
                            renderInput={(params) => (
                                <TextField {...params} placeholder={(selectedDestination.length == destinationaData?.maxSelectLimit) ? "" : "enter destination"} margin="normal" onKeyDown={handleKeyDown} />
                            )}
                            renderOption={(props, option, { inputValue }) => {
                                const matches = match(option.name, inputValue, { insideWords: true });
                                const parts = parse(option.name, matches);
                                return (
                                    <li {...props}>
                                        <div>
                                            {parts.map((part, index) => (
                                                <span
                                                    key={index}
                                                    style={{
                                                        fontWeight: part.highlight ? 700 : 400,
                                                    }}
                                                >
                                                    {part.text}
                                                </span>
                                            ))}
                                        </div>
                                    </li>
                                );
                            }}
                        />
                        {showMaxLimitErrMsg && <Body color={"#ff8027"}>{getErrorMessageVal('MAX_DESTINATIONS_REACHED')}</Body>}
                        {showDestRestMsg && (<ErrorRestriction><Icon ariaHidden={true} name="error" size="large" color="#ff8027"></Icon><Body color={"#ff8027"}>{destRestMsg}</Body></ErrorRestriction>)}
                        {selectedDestination && selectedDestination.length > 0 && (
                        <CountryListWrapper>
                            {selectedDestination.map((v) => (
                                <CountryBtn data-testid = {v?.name} onClick={() => onRemove(v)} onKeyUp={(e) => {(e.key === 'Enter' || e.key === ' ') ? onRemove(v) : e.preventDefault()}} tabIndex={0} aria-label={`Remove ${v?.name}`} role="button" border={v?.advisory && (v.advisory === 'DATA_SLOW' || v.advisory === 'DATA_UNAVAILABLE') ? "advisory" : ""}>
                                    {v?.advisory && (v.advisory === 'DATA_SLOW' || v.advisory === 'DATA_UNAVAILABLE') && <Icon ariaHidden={true} id="errorIcon" name="error" size="small" color="#ff8027"></Icon>}
                                    <Body bold size={"small"} >{v?.name}</Body>
                                    <span><Icon
                                        ariaHidden={true}
                                        name="close"
                                        size="small"
                                        color="#000000"
                                    /></span>
                                </CountryBtn>
                            ))}
                        </CountryListWrapper>
                        )}

                        {
                            (dataSlowList.length > 0 || dataUnavailableList.length > 0) && getAdvisoryMessage()
                        }

                        <Body><TextLink data-testid="coverageLinkId" onClick={() => openCoverageLink()}>{destinationaData?.coverageMapText}</TextLink></Body>
                        <Modal
                            opened={showAdvisoryModal}
                            surface="light"
                            onOpenedChange={onOpenedChange}
                            fullScreenDialog={false}
                            disableAnimation={false}
                            disableOutsideClick={false}
                            ariaLabel="Advisory Modal"
                            id="DestinationadvisoryModal"
                        >
                            <ModalTitle>
                                {advisoryModalDetails?.heading}
                            </ModalTitle>
                            <Space pt={32} />
                            <Line />
                            <ModalBody>
                                {
                                    advisoryModalDetails?.subHeading.map((adv, index) => {
                                        return <>
                                            <Body data-testid="modalBodyId" bold>{getAdvisoryCountryList(adv?.subHeadingHint)}</Body>
                                            <Space pt={12} />
                                            {adv.subText}
                                            {advisoryModalDetails?.subHeading?.length > 1 && index === 0 && <Space pt={24} />}
                                        </>
                                    })
                                }
                            </ModalBody>
                            <ModalFooter>
                                <StyledModalFooter>
                                    <Button data-testid="modalfooterButtonId" ariaLabel='advisoryModalCloseButton' onClick={() => { setShowAdvisoryModal(false) }}>{advisoryModalDetails?.ctaList[0].ctaLabel}</Button>
                                </StyledModalFooter>
                            </ModalFooter>
                        </Modal>
                        <Space pt={64} />
                    </DestinationPage>
                    <Footer ariaLabel={`no of places:${selectedDestination?.length}|next`} ctaLabel={destinationaData?.ctaList[0]?.ctaLabel} handleButtonChange={() => nextButtonClick()} disabled={selectedDestination?.length > 0 ? false : true}>
                    </Footer>
                </React.Fragment>)

                : (error && <ErrorPage errorDetails={error?.data} />)

            }
            {isLoading && <FullPageLoader />}
        </DestinationPageMain>
    )
}